"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _ShellNav = require("web/shared/shell/ShellNav.styles");
var _ShellNavHeading = _interopRequireDefault(require("web/shared/shell/ShellNavHeading"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A shell's sidebar on a wide viewport: its destinations in their groups,
* the current one marked, and whatever the shell puts at the foot. Links,
* not buttons — each is a page with a URL — and no chevrons: where a link
* sits and which one is lit is the whole of the navigation.
*
* Folded, it is the glyphs alone in a narrow rail, each centered in its
* link and named for a screen reader and on hover; the group headings
* give way to hairlines between the groups, so a fold reads as the same
* list drawn smaller, not a different one. Nothing mounts or unmounts as
* it folds: the headings and labels fade and fold in place, so the fold
* eases both ways with the column's width.
*
* After the destinations come any groups the shell draws rows for itself,
* such as an action, headed and spaced as every other group is.
*/
function ShellNav(_ref) {
  let label = _ref.label,
    groups = _ref.groups,
    current = _ref.current,
    onNavigate = _ref.onNavigate,
    trailingGroups = _ref.trailingGroups,
    foot = _ref.foot,
    collapsed = _ref.collapsed;
  const destinationGroups = groups.map(group => ({
    key: group.heading,
    heading: group.heading,
    pinnedToEnd: false,
    rows: group.destinations.map(destination => {
      const active = current != null && current.path === destination.path;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
          to: destination.path,
          "aria-current": active ? "page" : undefined,
          "aria-label": collapsed ? destination.label : undefined,
          title: collapsed ? destination.label : undefined,
          onClick: () => onNavigate(destination)
        }, stylex.props(_ShellNav.styles.link, active && _ShellNav.styles.linkActive, collapsed && _ShellNav.styles.linkCollapsed)), {}, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: destination.icon,
            size: "m"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellNav.styles.label, collapsed && _ShellNav.styles.labelHidden)), {}, {
            children: destination.label
          }))]
        }))
      }, destination.key);
    })
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("nav", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    "aria-label": label
  }, stylex.props(_ShellNav.styles.nav, collapsed && _ShellNav.styles.navCollapsed)), {}, {
    children: [[...destinationGroups, ...trailingGroups].map((group, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellNav.styles.group, index > 0 && _ShellNav.styles.groupAfterFirst, collapsed && index > 0 && _ShellNav.styles.groupDivided, group.pinnedToEnd && _ShellNav.styles.groupPinnedToEnd)), {}, {
      children: [group.heading == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShellNavHeading.default, {
        text: group.heading,
        collapsed: collapsed
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellNav.styles.list)), {}, {
        children: group.rows
      }))]
    }), group.key)), foot]
  }));
}
var _default = exports.default = ShellNav;